import React, { Component } from 'react';
import App_data from "../views/config/App_data";

let gisPromise = null;

export function loadGis() {
    if (window.google && window.google.accounts && window.google.accounts.id) {
        return Promise.resolve();
    }
    if (gisPromise) return gisPromise;

    gisPromise = new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = 'https://accounts.google.com/gsi/client';
        s.async = true;
        s.defer = true;
        s.onload = () => resolve();
        s.onerror = (e) => reject(e);
        document.head.appendChild(s);
    });

    return gisPromise;
}

class GoogleBtn extends Component {
    _unmounted = false;

    componentDidMount() {
        loadGis()
            .then(() => {
                if (this._unmounted) return;
                this.initAndRender();
            })
            .catch((e) => {
                console.error('GIS load failed', e);
                this.props.onError && this.props.onError(e);
            });
    }

    componentWillUnmount() {
        this._unmounted = true;
    }

    initAndRender = () => {
        if (!this.btnRef) return;
        this.btnRef.innerHTML = '';

        window.google.accounts.id.initialize({
            client_id: App_data.googleAuthClientID,
            callback: (resp) => {
                if (resp && resp.credential) {
                    this.props.onSuccess && this.props.onSuccess(resp);
                } else {
                    this.props.onError && this.props.onError(resp);
                }
            },
        });

        window.google.accounts.id.renderButton(this.btnRef, {
            theme: 'outline',
            size: 'large',
            width: 320,
        });
    };

    render() {
        return <div ref={(el) => (this.btnRef = el)} />;
    }
}

export default GoogleBtn;



// WEBPACK FOOTER //
// ./src/components/GoogleBtn.js